export default {
  addNewEvents(state, newEvents) {
    state.allEvents = [...state.allEvents, ...newEvents];
  },
  changeEventLoadingState(state, payload) {
    state.eventsLoading = payload;
  },
  changeEvents(state, events) {
    state.events = events;
  },
  setEventCount(state, newCount) {
    state.eventCount = newCount;
  },
  setPastEvents(state, newEvents) {
    state.pastEvents = newEvents;
  }
};
